<template>
  <div class="TextMaterialViewModal">
    <el-dialog
        title=""
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :append-to-body="true"
        :fullscreen="true"
        @open="handleOpen"
        width="100%"
    >

      <div class="contentBox">
        <el-form ref="form" size="mini" style="width: 100%">
          <el-form-item label="名称：" prop="name">
            <el-input
                readonly
                class="nameInput"
                placeholder="名称"
                v-model="name"
            ></el-input>
          </el-form-item>

          <template>
            <el-form-item label="内容:" prop="content">
              <el-input
                  readonly
                  class="textInput"
                  type="textarea"
                  placeholder="内容"
                  v-model="content"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div class="footer">
        <el-button
            style="width: 80px"
            type="primary"
            @click="handleClose"
        >关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: "TextMaterialViewModal",
  components: {},
  props: {
    materialInfo: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      name: null,
      content: "",
      loading: false,
    };
  },
  created() {
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.courseCenter.textMaterialVisible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "textMaterialVisible",
          value,
        });
      },
    }
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    handleOpen() {
      this.name = this.materialInfo.title;
      this.content = this.materialInfo.content;
    },
    handleClose() {
      this.setData({key: "textMaterialVisible", value: false});
    }
  },
};
</script>

<style lang="scss" scoped>
//.MultiContentModal {
::v-deep .el-dialog {
  min-width: 580px;
  min-height: 440px;
  position: relative;
  margin-top: 10vh !important;

  .el-dialog__header {
    box-shadow: none;
  }
}

::v-deep .el-upload-dragger {
  width: 300px;
}

::v-deep .el-textarea__inner {
  font-size: 1.5em;
  height: 50vh !important;
}

.cardSelect {
  border: solid 2px blue;
}

.contentBox {
  min-width: 400px;
  padding: 10px;
  font-size: 16px;
  background: #fafafa;
  letter-spacing: 0.1em;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .contentRow {
  }

  .addButton {
    height: 36px;
    width: 500px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #10689c;
  }
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 20px;
  right: 50px;
}

.MaterialCenter {
  .appBox {
  }
}

.tabSelect {
  background-color: #10689c;
  color: white;
}

.tabUnSelect {
}

.materialContent {
  margin-top: 20px;
  height: 430px;
  width: 685px;
  background-color: #ddd;
  float: left;

  .materialCard {
    float: left;
    width: 17.6%;
    height: 130px;
    overflow: hidden;
    margin-left: 2%;
    margin-top: 10px;

    .materialCardImage {
      background-color: white;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .materialCardAudio {
      background-color: white;
      width: 100%;
      height: 100%;
    }

    .materialCardVideo {
      background-color: white;
      width: 100%;
      height: 100%;
    }

    .materialCardText {
      background-color: white;
      width: 100%;
      height: 100%;
      padding: 10px;

      .materialCardTextTitle {
        font-size: 14px;
      }

      .materialCardTextContent {
        padding-top: 10px;
        font-size: 12px;
        padding-bottom: 10px;
        height: 90%;
        overflow: hidden;
        color: #999;
      }
    }
  }
}

.pagenation {
  text-align: center;
  clear: both;
  margin-top: -10px;
  display: flex;
  justify-content: center;
}

.findInput {
  width: 200px;
  float: right;
}

.findButton {
  float: right;
  margin-left: 0;
}

.addButton {
  float: right;
}

//}

//图片
.avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px solid #dcdfe6;
  margin-bottom: 20px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  margin-bottom: 10px;
}

.nameInput {
}

.textInput {
}
</style>
